import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Container, Paper, Typography, Button } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import { RZP_KEY } from "../../globals/const";
import {
  capturePayment,
  createOrder,
  getAvailableFarmPlans,
} from "../../api/subscription";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { planInfo } from "./plans";

export default function CreateFarmSubscription() {
  const navigate = useNavigate();
  const { farmId } = useParams();
  const { t } = useTranslation();
  const [planData, setPlanData] = useState(null);

  useEffect(() => {
    fetchPlans();

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const fetchPlans = async () => {
    const data = await getAvailableFarmPlans(farmId);
    setPlanData(data);
  };

  const verifyPayment = async (payment_data) => {
    const successful = capturePayment(
      payment_data.razorpay_order_id,
      payment_data.razorpay_payment_id,
      payment_data.razorpay_signature
    );
    if (successful) {
      alert("Payment successful");
      navigate("/my-subscriptions");
    }
  };

  const handleSubscribe = async (planKey) => {
    const result = await createOrder(farmId, planKey);
    const orderId = result.order_id;

    const options = {
      key: RZP_KEY,
      currency: "INR",
      name: "Farmapp subscription",
      description: "Subscribe to farmapp",
      image:
        "https://farmapp-stage.asqi.in/static/media/FarmAppLogo.73816e8df129dc26c289.png",
      order_id: orderId,
      handler: function (response) {
        verifyPayment(response);
      },
    };
    let rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <>
      <Helmet>
        <title>Create Subscription - Farmapp</title>
      </Helmet>
      <CustomAppBar title={t("Create Subscription")} />
      <Container maxWidth="xs">
        <Grid
          container
          justifyContent="center"
          direction="column"
          spacing={2}
          style={{ marginTop: "10px" }}
        >
          <Grid item>
            <CustomTitle>{t("Plans")}</CustomTitle>
            <Typography variant="subtitle1" color="textSecondary">
              {t("Select a plan for your farm ") + planData?.farm_name}
            </Typography>
          </Grid>
          {planData &&
            planData.pricing &&
            Object.entries(planData.pricing).map(([planKey, price]) => (
              <Grid item key={planKey}>
                <Paper style={{ padding: "10px" }}>
                  <Grid container alignItems="center">
                    <Grid item xs={12}>
                      <Typography variant="subtitle1">
                        {planInfo[planKey] ? planInfo[planKey].name : planKey}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {planInfo[planKey] ? planInfo[planKey].description : ""}
                      </Typography>
                      {planKey === "plan_premium" && planData.area && (
                        <Typography variant="body2" color="textSecondary">
                          {t("Area")}: {planData.area} acres
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} justifyContent="flex-end">
                      <CustomButton
                        onClick={() => handleSubscribe(planKey)}
                        hideIcon
                      >
                        {t("Subscribe for ₹") + price}
                      </CustomButton>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))}
          <Grid item>
            <Button onClick={() => navigate(-2)} variant="outlined">
              {t("Back")}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
